import { configureStore } from "@reduxjs/toolkit";
import loaderReducer from "./slices/loaderSlice";
import podReducer from "./slices/PODSlice";
import warningReducer from "./slices/WarningSlice";

// Configure our store combining all the state reducers.
export const store = configureStore({
  reducer: {
    pod: podReducer,
    loader: loaderReducer,
    warning: warningReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
